import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react'
import { Router } from 'react-router-dom'
import createSagaMiddleware from 'redux-saga'
import initializeApp from 'shared/initialize-app'
import reducer from 'store/reducers'
import sagas from 'store/sagas'
import history from 'routes/history'
import App from 'containers/app' 
import 'dom4'

const sagaMiddleware = createSagaMiddleware()
console.log(App)
const { store } = initializeApp({ 
  App,
  Router: ({children}) => <Router history={history}>{children}</Router>,
  reducer,
  reduxMiddleware: sagaMiddleware,
  beforeRender: () => {
    sagaMiddleware.run(sagas)
  },
})

export const dispatch = store.dispatch
